<script>
  // Idiosyncratic (only exists in this codebase -- assuming hand-edited by former dev). Close visual match to Iconoir, playlist-play
  export let iconClass = '';
</script>

<svg class={iconClass} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <title>Content</title>
  <path d="M1.33331 3.83331H13.3333M1.33331 7.83331H13.3333M1.33331 11.8333H9.33331M14.6666 12.1666L12.3333 13.8333V10.5L14.6666 12.1666Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>